import graphql__55a9088a95a40007bfc7 from "./__generated__/UsersMap_usersMap.graphql.js";import { graphql, useFragment } from "react-relay";

import MapContextProvider from "../MapContext";
import UsersMapDetailsManager from "../UsersMap/UsersMapDetailsManager";
import MapWithSidebarLayout from "../MapWithSidebarLayout";
import MapUsersPointsManager from "./MapUsersPointsManager";
import MapSidebar from "../MapSidebar";
import MapEventMarkersManager from "../MapEvent/MapEventMarkersManager";

const UsersMap = props => {
  const usersMap = useFragment(UsersMap_usersMap, props.usersMap);
  const { sidebar } = usersMap;

  return (
    <MapContextProvider map={usersMap}>
      <MapWithSidebarLayout map={usersMap}>
        <MapSidebar map={usersMap} sidebar={sidebar}>
          <UsersMapDetailsManager />
        </MapSidebar>

        <MapUsersPointsManager />
        <MapEventMarkersManager mapId={usersMap.id} />
      </MapWithSidebarLayout>
    </MapContextProvider>
  );
};

const UsersMap_usersMap = graphql__55a9088a95a40007bfc7;

export default UsersMap;
